import { RootState } from "../types";

export const getMainInfoSelector = (state: RootState) => state.info